<script>
export default {
    name: 'Nav',
    data() {
        return {
            scrolled: false,
            mobileOpen: false,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        onScroll() {
            this.scrolled = window.scrollY > 20
        },
        scrollTo(id) {
            this.mobileOpen = false
            const el = document.getElementById(id)
            if (el) el.scrollIntoView({ behavior: 'smooth' })
        },
    },
}
</script>

<template>
    <nav :class="['site-nav', { scrolled: scrolled }]">
        <div class="nav-inner">
            <a href="/" class="nav-logo-link">
                <img src="@/assets/images/shiftos-logo-simplified-web.png" alt="Sim Racing Support" class="nav-logo-img" />
            </a>

            <div class="nav-links">
                <b-button class="nav-link" @click="scrollTo('services')">Services</b-button>
                <b-button class="nav-link" @click="scrollTo('shiftos')">ShiftOS</b-button>
                <b-button class="nav-link" @click="scrollTo('supported')">We Support</b-button>
                <b-button class="nav-link" @click="scrollTo('ticket')">Submit a Ticket</b-button>
            </div>

            <div class="nav-cta">
                <b-button class="btn-primary-red btn-sm" @click="scrollTo('ticket')">Get Help <span class="arrow">→</span></b-button>
            </div>

            <b-button class="mobile-toggle" @click="mobileOpen = !mobileOpen" aria-label="Toggle menu">
                <i :class="mobileOpen ? 'ph ph-x' : 'ph ph-list'"></i>
            </b-button>
        </div>

        <div v-if="mobileOpen" class="mobile-menu">
            <b-button class="mobile-link" @click="scrollTo('services')">Services</b-button>
            <b-button class="mobile-link" @click="scrollTo('shiftos')">ShiftOS</b-button>
            <b-button class="mobile-link" @click="scrollTo('supported')">We Support</b-button>
            <b-button class="mobile-link mobile-link-cta" @click="scrollTo('ticket')">Submit a Ticket →</b-button>
        </div>
    </nav>
</template>

<style scoped>
.site-nav {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid #e5e7eb;
    transition: box-shadow 0.2s;
}

.site-nav.scrolled {
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
}

.nav-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    padding: 0 28px;
    max-width: 1140px;
    margin: 0 auto;
}

.nav-logo-link {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.nav-logo-img {
    height: 36px;
    width: auto;
    display: block;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 2px;
}

.nav-link {
    padding: 7px 13px;
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
    border-radius: 6px;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.15s, background 0.15s;
    font-family: 'Inter', system-ui, sans-serif;
}

.nav-link:hover {
    color: #111827;
    background: #f5f7fa;
}

.nav-cta {
    display: flex;
    align-items: center;
}

.btn-primary-red {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #e8201a;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-family: 'Inter', system-ui, sans-serif;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, transform 0.15s;
    white-space: nowrap;
}

.btn-primary-red:hover {
    background: #c01814;
    transform: translateY(-1px);
    color: #fff;
}

.btn-sm {
    padding: 9px 16px;
    font-size: 13px;
}

.arrow {
    transition: transform 0.15s;
}

.btn-primary-red:hover .arrow {
    transform: translateX(3px);
}

.mobile-toggle {
    display: none;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    color: #111827;
    padding: 4px;
    line-height: 1;
}

.mobile-menu {
    display: none;
    flex-direction: column;
    padding: 12px 20px 20px;
    border-top: 1px solid #e5e7eb;
    background: #fff;
}

.mobile-link {
    display: block;
    width: 100%;
    text-align: left;
    padding: 12px 8px;
    font-size: 16px;
    font-weight: 500;
    color: #374151;
    background: none;
    border: none;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    font-family: 'Inter', system-ui, sans-serif;
}

.mobile-link:last-child {
    border-bottom: none;
}

.mobile-link-cta {
    color: #e8201a;
    font-weight: 700;
    margin-top: 8px;
    border-bottom: none;
}

@media (max-width: 768px) {
    .nav-links,
    .nav-cta {
        display: none;
    }

    .mobile-toggle {
        display: block;
    }

    .mobile-menu {
        display: flex;
    }
}
</style>
